import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const GET_IN_APP_NOTIFICATIONS_REQUEST = 'GET_IN_APP_NOTIFICATIONS_REQUEST';
export const GET_IN_APP_NOTIFICATIONS_SUCCESS = 'GET_IN_APP_NOTIFICATIONS_SUCCESS';
export const GET_IN_APP_NOTIFICATIONS_ERROR = 'GET_IN_APP_NOTIFICATIONS_ERROR';

export const GET_MARK_ALL_READ_REQUEST = 'GET_MARK_ALL_READ_REQUEST';
export const GET_MARK_ALL_READ_SUCCESS = 'GET_MARK_ALL_READ_SUCCESS';
export const GET_MARK_ALL_READ_ERROR = 'GET_MARK_ALL_READ_ERROR';

export function getInAppNotificationsAction() {
	return { type: GET_IN_APP_NOTIFICATIONS_REQUEST };
}

export function getInAppNotificationsSuccessAction(data) {
	return { type: GET_IN_APP_NOTIFICATIONS_SUCCESS, data };
}

export function getInAppNotificationsErrorAction(error) {
	return { type: GET_IN_APP_NOTIFICATIONS_ERROR, error };
}

export function fetchInAppNotificationsAction(count = 5) {
	return dispatch => {
		dispatch(getInAppNotificationsAction());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/2/notification?count=${count}&before=${new Date().getTime()}`
			})
		).then(
			json => dispatch(getInAppNotificationsSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getInAppNotificationsErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export function getMarkAllReadRequestAction() {
	return { type: GET_MARK_ALL_READ_REQUEST };
}

export function getMarkAllReadSuccessAction(data) {
	return { type: GET_MARK_ALL_READ_SUCCESS, data };
}

export function getMarkAllReadErrorAction(error) {
	return { type: GET_MARK_ALL_READ_ERROR, error };
}

export function markAllNotificationAsReadAction() {
	return dispatch => {
		dispatch(getMarkAllReadRequestAction());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/2/notification/markAllRead'
			})
		).then(
			json => dispatch(getMarkAllReadSuccessAction(json['RESPONSE'])),
			err => {
				dispatch(getMarkAllReadErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
